
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:Navigation:Loaded',function(event){
    let e = event.detail.settings;
      for (let i = 0; i < e.navs.length; i++) {
        if(e.navs[i].title == "Top Ordered Products" && e.navs[i].url == "#topOrder"){
          e.navs[i].isShow = 0;
        }
        if(e.navs[i].title == "Recently Viewed" && e.navs[i].url == "#recentlyView"){
          e.navs[i].isShow = 0;
        }
      } 
  })
}(Flits));
